export default "__VITE_ASSET__DPYz8X1x__"